export default __webpack_public_path__ + "static/media/hyundai.b09bf491.svg";